import { createAction, props } from "@ngrx/store";
export const streetsSearch = createAction('[tab-streets] streetsSearch', props());
